import { subjectTypes } from 'z-js-commons';

function mapMenuItem(subject) {
    return {
        image: subjectTypes.getSubjectPath(subject),
        subjectName: subject
    };
}

export const juniorHighSchoolSubjects = [
    subjectTypes.MATH,
    subjectTypes.SCIENCE_MIDDLE_SCHOOL,
    subjectTypes.ITALIAN,
    subjectTypes.GEOGRAPHY_MIDDLE_SCHOOL,
    subjectTypes.ENGLISH,
    subjectTypes.FRENCH,
    subjectTypes.HISTORY,
    subjectTypes.ART_IMAGE,
    subjectTypes.SPANISH,
    subjectTypes.TECHNOLOGY
].map(mapMenuItem);

export const highSchoolSubjects = [
    subjectTypes.MATH,
    subjectTypes.PHYSICS,
    subjectTypes.BIOLOGY,
    subjectTypes.CHEMISTRY,
    subjectTypes.EARTH_SCIENCE,
    subjectTypes.ITALIAN,
    subjectTypes.ENGLISH,
    subjectTypes.FRENCH,
    subjectTypes.SPANISH,
    subjectTypes.GERMAN,
    subjectTypes.ART,
    subjectTypes.GEOGRAPHY_HIGH_SCHOOL,
    subjectTypes.LAW,
    subjectTypes.GREEK,
    subjectTypes.COMPUTER_SCIENCE,
    subjectTypes.HISTORY,
    subjectTypes.FOOD_SCIENCE,
    subjectTypes.TECHNICAL_DESIGN
].map(mapMenuItem);
